import React, { useEffect, useState, createElement } from 'react';
import { ArrowRightIcon, MousePointerClickIcon, SearchIcon, PuzzleIcon, PlugIcon, SmartphoneIcon, GaugeIcon, ShieldCheckIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { AlkmaarSkyline } from '../components/AlkmaarSkyline';
export function WordPressWebsiteAlkmaarPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'WordPress website Alkmaar | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'WordPress website laten maken in Alkmaar? Flexibele, snelle en SEO-vriendelijke WordPress websites voor ondernemers in Alkmaar. Door Noord Digital.';
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: 'Waarom is WordPress een goede keuze voor mijn website?',
    a: 'WordPress is het meest gebruikte CMS ter wereld en wordt ingezet door meer dan 40% van alle websites. Het is gebruiksvriendelijk, flexibel uitbreidbaar en uitstekend geschikt voor SEO. Daardoor is het de ideale basis voor een professionele bedrijfswebsite in Alkmaar.'
  }, {
    q: 'Is WordPress veilig genoeg voor mijn bedrijfswebsite?',
    a: 'Ja, mits het goed wordt onderhouden. Wij zorgen voor veilige hosting, regelmatige updates, SSL-certificaten en beveiligingsplugins. Zo blijft jouw WordPress website in Alkmaar altijd beschermd tegen bedreigingen.'
  }, {
    q: 'Kan ik zelf de content van mijn WordPress website aanpassen?',
    a: "Absoluut. WordPress is ontworpen om eenvoudig te beheren. Na oplevering geven wij je een uitgebreide uitleg zodat je zelf teksten, afbeeldingen en pagina's kunt aanpassen zonder technische kennis."
  }];
  return <main className="pt-16 lg:pt-[72px]" data-id="element-3033">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-3034">
        <div className="absolute inset-0 pointer-events-none" data-id="element-3035">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-3036" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-3037" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-3038" />
        </div>

        {/* Alkmaar Skyline */}
        <div className="absolute bottom-0 left-0 right-0 opacity-[0.08] pointer-events-none" data-id="element-3039">
          <AlkmaarSkyline className="w-full h-auto" color="#ffffff" data-id="element-3040" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3041">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 animate-fade-in-up" data-id="element-3042">
            WordPress website laten maken in Alkmaar
          </h1>
          <p className="text-lg lg:text-xl text-navy-200 max-w-2xl mx-auto mb-10 animate-fade-in-up-delay-1" data-id="element-3043">
            Flexibele en SEO-vriendelijke websites voor ondernemers in Alkmaar.
            Gebouwd op WordPress, het meest betrouwbare CMS ter wereld.
          </p>
          <div className="animate-fade-in-up-delay-2" data-id="element-3044">
            <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-bold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-lg" data-id="element-3045">
              Plan een gesprek
              <ArrowRightIcon className="w-5 h-5" data-id="element-3046" />
            </a>
          </div>
        </div>
      </section>

      {/* Waarom WordPress */}
      <section className="py-24 bg-surface-muted" data-id="element-3047">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3048">
          <div className="text-center mb-16" data-id="element-3049">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3050">
              Waarom WordPress?
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-3051">
              WordPress is de beste keuze voor ondernemers die een
              professionele, beheersbare website willen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3052">
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3053">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3054">
                <MousePointerClickIcon className="w-6 h-6 text-accent" data-id="element-3055" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3056">
                Gebruiksvriendelijk
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3057">
                Pas zelf eenvoudig teksten, afbeeldingen en pagina's aan zonder
                technische kennis.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3058">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3059">
                <SearchIcon className="w-6 h-6 text-accent" data-id="element-3060" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3061">
                SEO-vriendelijk
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3062">
                WordPress biedt uitstekende SEO-mogelijkheden waardoor je beter
                gevonden wordt in Google.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3063">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3064">
                <PuzzleIcon className="w-6 h-6 text-accent" data-id="element-3065" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3066">
                Flexibel uitbreidbaar
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3067">
                Groeit jouw bedrijf? Dan groeit je WordPress website moeiteloos
                mee met extra functionaliteiten.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3068">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3069">
                <PlugIcon className="w-6 h-6 text-accent" data-id="element-3070" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3071">
                Veel integraties
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3072">
                Koppel eenvoudig tools zoals Google Analytics, mailchimp,
                boekingssystemen en meer.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WordPress voor bedrijven */}
      <section className="py-24 bg-white" data-id="element-3073">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3074">
          <div className="text-center mb-16" data-id="element-3075">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3076">
              WordPress webdesign voor bedrijven in Alkmaar
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-3077">
              Elke WordPress website die wij bouwen voldoet aan de hoogste
              standaarden.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3078">
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-3079">
              <div className="flex items-start gap-4" data-id="element-3080">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3081">
                  <SmartphoneIcon className="w-6 h-6 text-navy-700" data-id="element-3082" />
                </div>
                <div data-id="element-3083">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3084">
                    Responsive design
                  </h3>
                  <p className="text-slate-600" data-id="element-3085">
                    Jouw WordPress website ziet er perfect uit op elk apparaat,
                    van mobiel tot desktop.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-3086">
              <div className="flex items-start gap-4" data-id="element-3087">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3088">
                  <SearchIcon className="w-6 h-6 text-navy-700" data-id="element-3089" />
                </div>
                <div data-id="element-3090">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3091">
                    SEO-basis
                  </h3>
                  <p className="text-slate-600" data-id="element-3092">
                    Technische SEO-optimalisatie is standaard inbegrepen, zodat
                    je direct vindbaar bent in Alkmaar en omgeving.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-3093">
              <div className="flex items-start gap-4" data-id="element-3094">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3095">
                  <GaugeIcon className="w-6 h-6 text-navy-700" data-id="element-3096" />
                </div>
                <div data-id="element-3097">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3098">
                    Snelle laadtijd
                  </h3>
                  <p className="text-slate-600" data-id="element-3099">
                    Wij optimaliseren elke WordPress website voor snelheid, wat
                    zorgt voor een betere gebruikerservaring en hogere
                    Google-ranking.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-3100">
              <div className="flex items-start gap-4" data-id="element-3101">
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3102">
                  <ShieldCheckIcon className="w-6 h-6 text-navy-700" data-id="element-3103" />
                </div>
                <div data-id="element-3104">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3105">
                    Beveiliging
                  </h3>
                  <p className="text-slate-600" data-id="element-3106">
                    SSL-certificaat, beveiligingsplugins en regelmatige updates
                    houden jouw website veilig en beschermd.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Proces */}
      <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-3107">
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-3108" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3109">
          <div className="text-center mb-16" data-id="element-3110">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-3111">
              Ons proces
            </h2>
            <p className="text-lg text-navy-300 max-w-2xl mx-auto" data-id="element-3112">
              In 5 heldere stappen naar jouw WordPress website in Alkmaar.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6" data-id="element-3113">
            {['Kennismaking', 'Strategie', 'Ontwerp', 'Ontwikkeling', 'Livegang'].map((step, i) => <div key={step} className="bg-white/[0.06] border border-white/10 p-6 rounded-2xl text-center relative" data-id="element-3114">
                <span className="absolute top-2 right-4 text-4xl font-bold text-white/[0.05]" data-id="element-3115">
                  {i + 1}
                </span>
                <div className="w-10 h-10 rounded-full bg-accent/20 text-accent flex items-center justify-center mx-auto mb-4 font-bold" data-id="element-3116">
                  {i + 1}
                </div>
                <h3 className="text-white font-bold" data-id="element-3117">{step}</h3>
              </div>)}
          </div>
        </div>
      </section>

      {/* Gerelateerde pagina's */}
      <section className="py-16 bg-white border-b border-navy-100" data-id="element-3118">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3119">
          <h3 className="text-lg font-semibold text-navy-900 mb-6" data-id="element-3120">
            Ontdek meer:
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-3121">
            <a href="#/website-laten-maken" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3122">
              Website laten maken
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-3123">•</span>
            <a href="#/wordpress-websites" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3124">
              WordPress websites
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-3125">•</span>
            <a href="#/hosting-onderhoud" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3126">
              Hosting & onderhoud
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-surface-muted" data-id="element-3127">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3128">
          <div className="text-center mb-16" data-id="element-3129">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3130">
              Veelgestelde vragen over WordPress in Alkmaar
            </h2>
          </div>

          <div className="space-y-4" data-id="element-3131">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-soft overflow-hidden" data-id="element-3132">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-3133">
                  <span className="font-bold text-navy-900" data-id="element-3134">{faq.q}</span>
                  {openFaq === index ? <ChevronUpIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-3135" /> : <ChevronDownIcon className="w-5 h-5 text-navy-400 flex-shrink-0" data-id="element-3136" />}
                </button>
                {openFaq === index && <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-3137">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <FinalCtaSection data-id="element-3138" />
    </main>;
}